import { ComprobanteRetencion } from '../interfaces/comprobante-retencion.interface'

export const comprobanteRetencionInitialState: ComprobanteRetencion = {
  formCliente: {
    fecha: new Date().toLocaleDateString('en-CA'),
    tipoDocumento: '36',
    nombreTipoDocumento: 'NIT',
    numId: '',
    nombre: '',
    departamento: '',
    nombreDepartamento: '',
    municipio: '',
    nombreMunicipio: '',
    distrito: '',
    nombreDistrito: '',
    direccion: '',
    email: '',
    chipsEmail: [],
    telefono: '',
    actividad: "",
    nrc: "",
    descripcion: "",
    correocc: '',
  },
  errorsFormCliente: {
    fecha: '',
    tipoDocumento: '',
    numId: '',
    nombre: '',
    departamento: '',
    municipio: '',
    distrito: '',
    direccion: '',
    email: '',
    telefono: '',
    actividad: "",
    nrc: "",
    descripcion: "",
    correocc: '',
  },
  formProductos: {
    tipo: 'p',
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: 'porcentaje',
    descuento: '0',
    cantidadDescuento: '0.00',
    subtotal: '0.00',
    total: '0.00',
    totalImpuesto1: '0.00',
    totalImpuesto2: '0.00',
    impuesto1: '0.00',
    impuesto2: '0.00',
    totalConImpuesto1: '0.00',
    subTotalConImpuesto1: '0.00',
    totalConImpuesto1Desc: '0.00',
  },
  errorsFormProductos: {
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: '',
    descuento: '',
    cantidadDescuento: '',
    subtotal: '',
    total: '',
  },
  formSucursal: {
    sucursal: '',
    serie: '',
    datosSucursal: null,
    datosSerie: null,
  },
  errorsFormSucursal: {
    sucursal: '',
    serie: '',
  },
  productoSeleccionado: null,
  productoEdit: {
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: 'porcentaje',
    descuento: '',
    cantidadDescuento: '0.00',
    subtotal: '0.00',
    total: '0.00',
    totalImpuesto1: '0.00',
    totalImpuesto2: '0.00',
    impuesto1: '0.00',
    impuesto2: '0.00',
    totalConImpuesto1: '0.00',
    subTotalConImpuesto1: '0.00',
    totalConImpuesto1Desc: '0.00',
  },
  formProductosEdit: {
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: 'porcentaje',
    descuento: '',
    cantidadDescuento: '0.00',
    subtotal: '0.00',
    total: '0.00',
  },
  errorsFormProductosEdit: {
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: '',
    descuento: '',
    cantidadDescuento: '',
    subtotal: '',
    total: '',
  },
  arrayProductos: [],
  calculosArrayProductos: {
    totalIvaRetenido: '0.00',
    totalMontoSujeto: '0.00',
  },
  modals: {
    activeQuitarTodo: false,
    activeEliminarUno: false,
    activeEditar: false,
    activeEmitirFactura: false,
    activeFacturaEmitida: false,
    activeImpresion: false,
    modoTicketPrint: false,
    activeEmail: false,
    activeAnular: false,
  },
  datosEmisor: {},
  datosFacturaRes: {},
  facturaEmitda: false,
  opcionesActiva: false,
  catalogoSucursal: [],
  catalogoSerie: [],
  datosUUID: null,
  anulado: false,
  sucursalesCargadas: false,
  modalDocumentos: {
    open: false,
    loader: false,
    user: {
      tipoDoc: "",
      numId: ""
    },
    form: {
      inicio:  new Date().toLocaleDateString('en-CA'),
      fin: new Date().toLocaleDateString('en-CA'),
      tipo: "",
      numId: "",
      nombre: ""
    }, 
    errorForm: {
      inicio: "",
      fin: "",
      tipo: "",
      numId: "",
      nombre: ""
    },
    documentos: []
  },
  documentosAsociados: [],
  fisico: {
    form: {
      tipo: "",
      numId: "",
      fecha: new Date().toLocaleDateString('en-CA'),
      descripcion: "",
      monto: "",
      retencion: "0.00",
    },
    errorForm: {
      tipo: "",
      numId: "",
      fecha: "",
      descripcion: "",
      monto: "",
      retencion: "",
    },
    open: false,
    edit: false,
    id: "",
  },
  formObservaciones: {
    referencia: '',
    observaciones: '',
    mostrarObservacionesPdf: true,
    incluirObservacionesCorreo: true,
  },
}

export const comprobanteRetencionInitialState2 = JSON.parse(JSON.stringify(comprobanteRetencionInitialState))